import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import LanguageModel from '@/views/Language/models/language'

@Component({
    inheritAttrs: false,
    name: 'language-add',
    components: { DialogTemplate },
})
export default class LanguageAdd extends Mixins<MixinInterface>() {
    language = ''

    get languageList() {
        return this.languageDB.filter((langDB) => {
            return (
                this.$store.getters.languages.findIndex((lang) => lang._id == langDB['639-2']) == -1
            )
        })
    }

    loading = false
    languageAlreadyExists = false

    languageRules(languageAlreadyExists) {
        return languageAlreadyExists
            ? this.getComplexTranslations(
                  'language_fe.language.dialog_add.validation.languageAlreadyExists'
              )
            : true
    }

    async postLanguage() {
        this.loading = true
        let res = await LanguageModel.post(this.language).catch((error) => {
            if (error.code == 'languageAlreadyExists') {
                this.$store.commit('closeSnackbar')
                this.languageAlreadyExists = true
            }
        })
        this.loading = false

        if (res) {
            this.$emit('close', false)
        }
    }
}
